import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Layout from "./components/Layout";
import Index from "./pages/Index";
import Characters from "./pages/Characters";
import CharacterDetail from "./pages/CharacterDetail";
import Activities from "./pages/Activities";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import AboutUs from "./pages/AboutUs";
import StoryOfQueebiLand from "./pages/StoryOfQueebiLand";
import Collaborate from "./pages/Collaborate";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Audiobook from "./pages/Audiobook";
import ImageLibrary from "./pages/ImageLibrary";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLibrary from "./pages/admin/AdminLibrary";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const AudioRedirect = () => {
  const location = useLocation();
  return <Navigate to={`/audiobook${location.search}`} replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<Index />} />
      <Route path="/audio" element={<AudioRedirect />} />
      <Route path="/queebi-land-characters" element={<Characters />} />
      <Route path="/activities" element={<Activities />} />
      <Route path="/queebi-products" element={<Products />} />
      <Route path="/queebi-products/:slug" element={<ProductDetail />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/story-of-queebi-land" element={<StoryOfQueebiLand />} />
      <Route path="/collaborate" element={<Collaborate />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/audiobook" element={<Audiobook />} />
      <Route path="/:slug" element={<CharacterDetail />} />
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            {/* Hidden internal routes (no Layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/library" element={<AdminLibrary />} />
            <Route path="/image-library" element={<ImageLibrary />} />
            {/* Explicit language-prefixed routes */}
            <Route path="/zh/*" element={<AppRoutes />} />
            <Route path="/ja/*" element={<AppRoutes />} />
            {/* Default English routes */}
            <Route path="/*" element={<AppRoutes />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
